export const URLS = {
	MORTALITY_DISTRIBUTION: 'analises/mortalidade-percentual/',
	API_ESTABELECIMENTO: process.env.VUE_APP_URL_API_ESTABELECIMENTO,
	TIPO_COMEDOURO: 'tipoComedouro/',
	TIPO_BEBEDOURO: 'tipoBebedouro/',
	TIPO_PISO: 'tipoPiso/',
	TECHNICAL_MANAGERS: 'responsavel-tecnico/responsavel_tecnico_ativo/',
	UNIDADE_EXPLORACAO: 'unidadeExploracao/',
	ESTABELECIMENTO: 'estabelecimento/',
	TABELA_META_MORTALIDADE: 'tabela-meta-mortalidade/',
	ESTABELECIMENTO_LOTES_ATIVOS: 'lote-producao/estabelecimento_lotes_ativos/'
};
